/**
 * @fileoverview PUT handler for the "/companies/:company_id/feature_management/set_feature_statuses" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdFeatureManagementSetFeatureStatusCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdFeatureManagementSetFeatureStatusProps,
  PutCompanyFeatureStatusesResult,
} from "./types";

export const putCompanyFeatureStatuses = reactQueryMutationAdapter(
  companiesCompanyIdFeatureManagementSetFeatureStatusCacheKeys,
  (
    props: PutCompaniesCompanyIdFeatureManagementSetFeatureStatusProps
  ): Promise<PutCompanyFeatureStatusesResult> => {
    return fetch(`/companies/${props.companyId}/feature_management/set_feature_statuses`, "PUT", props);
  }
);
